import "./IconLanguages.scss";
import { ReactComponent as LanguagesIcon } from "./svg/icon_languages.svg";

export const IconLanguages = () => {
  return (
    <span className="IconLanguages">
      <LanguagesIcon />
    </span>
  );
};
